<script>
import Loading from "@/components/layout/Loading.vue";
import { EventBus } from '@/eventBus';
export default {
  name: "UsuarioWidget",
  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    icon_url: {
      type: String,
      required: false,
    },
    comment: {
      type: Boolean,
      required: true,
    },
    link: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Loading,
  },
  methods: {
    sendMessage(user) {
      EventBus.$emit("actionFn", { fn:"enviarMensaje", params:user});
      
    }
  },
};
</script>
<template>
  <section class="widget">
    <Loading v-if="loading" pixeles="100px" class="mb-3" />
    <div
      v-if="!loading"
      class="card card-custom card-custom-h-450 border-0 mb-3"
    >
      <div
        class="d-flex justify-content-between align-items-center p-3 pb-0 color-main"
      >
        <p class="d-flex align-items-center font-title font-700 mb-0">
          <img height="40" :src="$basePath + icon_url" />
          <span>{{ title }}</span>
        </p>
        <router-link
          v-if="link"
          class="font-title font-700 color-main"
          to="/birthday"
        >
          Ver más
        </router-link>
      </div>
      <div v-if="data.length !== 0" class="card-body scroll max-h-400">
        <div
          v-for="item in data"
          :key="item.id_usuario"
          class="d-flex align-items-start card-shadow-light rounded p-2 mb-3"
        >
          <div class="flex-shrink-0">
            <img
              width="40"
              height="40"
              class="img-object-cover rounded-circle"
              v-if="
                !item.imagen_perfil ||
                !/.jpg|.jpeg|.png/.test(item.imagen_perfil)
              "
              src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
            />
            <img
              v-else
              width="40"
              height="40"
              class="img-object-cover rounded-circle"
              :src="item.imagen_perfil"
            />
          </div>
          <div class="flex-grow-1 ms-3">
            <p class="d-grid text-secondary mb-0">
              <strong class="ellipsis-custom">
                {{ capitalizeFirstLetter(item.primer_nombre) }}
                {{ capitalizeFirstLetter(item.apellido_paterno) }}
              </strong>
              <span class="text-secondary text-opacity-75 ellipsis-custom">
                <span v-if="item.cargo[0] !== null">
                  Cargo: {{ capitalizeFirstLetter(item.cargo[0].nombre_cargo) }}
                </span>
                <span v-if="item.cargo[0] === null">
                  Cargo: Sin informacion
                </span>
              </span>
              <span class="text-secondary text-opacity-75 ellipsis-custom">
                <span v-if="item.sucursal[0] !== null">
                  Lugar:
                  {{ capitalizeFirstLetter(item.sucursal[0].nombre_sucursal) }}
                </span>
                <span v-if="item.sucursal[0] === null">
                  Lugar: Sin informacion
                </span>
              </span>
            </p>
          </div>
          <a href="javascript:" class="fs-4 color-main" @click="sendMessage(item)" > 
            <font-awesome-icon
              icon="fa-solid fa-comment-dots"
            ></font-awesome-icon>
          </a>
        </div>
      </div>
      <div v-if="data.length === 0" class="card-body">
        <div
          class="alert alert-light text-center border mb-0 text-secondary text-opacity-75"
        >
          <font-awesome-icon icon="fa-solid fa-circle-info"></font-awesome-icon>
          Sin información
        </div>
      </div>
    </div>
  </section>
</template>
<style>

</style>